<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import SinglePublish, { updateSinglePublish } from "../Stores/singlePublishStore"
  import { onMount } from "svelte"
  import axios from "axios"
  import notify from "../../../../Script/notify"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import { checkValidDate } from "../script"
  import { push, querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import Header from "../Components/Header.svelte"
  import LoadingScreen from "../Components/loadingScreen.svelte"
  import { getDocumentIdDetails } from "../script"
  import AdditionalData from "../Components/additionalData.svelte"
  import ConfirmationModal from "../../BulkUpload/Shared/confirmationModal.svelte"

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let apiCallBtnDisable = false

  /**
   * @type {String} - massage for loading screen
   */
  let msg

  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {Element} - document template shown element
   */
  let mainDiv

  /**
   * @type {Number} - max charater for metadata's value
   */
  let maxCharacters = 78

  /**
   * @type {emptyFieldNotify}
   */
  let emptyFieldNotify = {
    close() {},
  }

  /**
   * @type {maxNotification}
   */
  let maxNotification = {
    close() {},
  }

  /**
   * @type {noDocumentTemplateNotify} - document template not selected notification
   */
  let noDocumentTemplateNotify = {
    close() {},
  }

  /**
   * @type {notificationExpired}
   */
  let notificationExpired = {
    close() {},
  }

  let showConfirmationModal = false

  /**
   * fetch new document id details if the contition is satisfied
   */
  onMount(async () => {
    try {
      //set new documnet id details to the local storage
      // if ($SinglePublish.documentId != query.documentId) await getDocumentIdDetails()
      // else {
      if ($SinglePublish.documentTemplateId == "") push(`/publish/single/choose_template`)
      if (mainDiv) mainDiv.scrollIntoView()
      // }
    } catch (error) {
      const info = "PAGE: Single Publish (Edit Document Metadata)\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  })

  /**
   * @description check max character function for metadata value
   */
  const checkMaxCharacters = async (e, parent, key) => {
    let inputValue
    if (e.target.value.length > maxCharacters) {
      maxNotification.close()
      //returning values only in range below max characters using slice method after a delay of 20ms
      inputValue = e.target.value.slice(0, maxCharacters + 1)
      if (parent == "options") $SinglePublish.optionsTitle = inputValue
      else $SinglePublish.Json[parent][key] = inputValue
      //Throw notification for exceeding max Characters
      maxNotification = notify.info(`Cannot enter more than 80 characters`)
    }
  }

  /**
   * @description update the metadata value based on user input
   */
  const updateValue = (e, parent, key) => {
    if (parent == "options") $SinglePublish.optionsTitle = e.target.value.trim()
    else $SinglePublish.Json[parent][key] = e.target.value.trim()
  }

  /**
   * @description before redirect next page check any metadata value fields are empty
   */
  const checkEmpty = () => {
    return new Promise((resolve, reject) => {
      try {
        let parent = Object.keys($SinglePublish.Json)
        for (let i = 0; i < parent.length; i++) {
          let keys = Object.values($SinglePublish.Json[parent[i]])
          for (let j = 0; j < keys.length; j++) {
            if (!keys[j]) {
              throw "Don't leave empty field"
            }
          }
        }
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * @description metadata submit function
   */
  const metadataSubmit = async (sampleObj) => {
    return new Promise(async (resolve, reject) => {
      /**
       * @description updating template details with changes made using patch method
       */
      try {
        apiCallBtnDisable = true
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        // const { data } = await axios.post(`/api/swagger/v2/docs/add-data`, sampleObj, {
        const { data } = await axios.patch(`/api/swagger/v2/documents/${$SinglePublish.documentId}/add-data`, sampleObj, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })

        if (data.error && !data.success) {
          //throw if any error occurs during api call
          throw data.errorCode
        }
        $SinglePublish.options = JSON.parse(data.options)
        $SinglePublish.Json = JSON.parse(data.metadata)
        $SinglePublish.dataHash = data.dataHash
        push(`/publish/single/preview?documentId=${$SinglePublish.documentId}`)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * @description function for goto docPreview page
   */
  const nextPage = async () => {
    try {
      if (!$SinglePublish.documentTemplateId) throw "Choose Document Template"

      await checkEmpty()

      for (let i = 0; i < $SinglePublish.fields.length; i++) {
        let key = $SinglePublish.fields[i].key.trim()
        let value = $SinglePublish.fields[i].value.trim()

        if (!key || !value) throw "Don't leave empty fields"
      }

      showConfirmationModal = true
    } catch (error) {
      console.error(error)
      emptyFieldNotify.close()
      const info = "PAGE: Single Publish (Edit Document Metadata)\nEVENT: During validation of metadata fields before proceeding to publish"
      emptyFieldNotify = notify.danger(error, info)
    } finally {
      updateSinglePublish($SinglePublish)
      apiCallBtnDisable = false
    }
  }

  /**
   * @description function for check user given date doesn't older
   */
  const checkDate = async (e) => {
    try {
      await checkValidDate(e)
    } catch (error) {
      $SinglePublish.expiryOn = ""
      notificationExpired.close()
      const info = "PAGE: Single Publish (Edit Document Metadata)\nEVENT: Expiry date validation on input change"
      notificationExpired = notify.danger(error, info)
    }
  }

  const handlePublishConfirmation = async () => {
    try {
      showConfirmationModal = false
      msg = "Updating metadata"
      apiCallBtnDisable = true

      for (let i = 0; i < $SinglePublish.fields.length; i++) {
        let key = $SinglePublish.fields[i].key.trim()
        let value = $SinglePublish.fields[i].value.trim()
        let parent = $SinglePublish.fields[i].parent

        $SinglePublish.Json[parent][key] = value
      }

      const REQ_BODY = {
        metadata: JSON.stringify($SinglePublish.Json),
        options: {},
      }
      REQ_BODY.options.signed = $SinglePublish.signedPDFName ? ($SinglePublish.signedPDF = true) : $SinglePublish.signedPDF
      if ($SinglePublish.optionsTitle) REQ_BODY.options.title = $SinglePublish.optionsTitle
      if ($SinglePublish.expiryOn) REQ_BODY.options.expireOn = new Date($SinglePublish.expiryOn).toISOString()
      if ($SinglePublish.docketId) REQ_BODY.options.docket = $SinglePublish.docketId

      await metadataSubmit(REQ_BODY)

      $SinglePublish.fields = []
    } catch (error) {
      console.error(error)
      emptyFieldNotify.close()
      const info = "PAGE: Single Publish (Edit Document Metadata)\nEVENT: While updating metadata detaiils before publish"
      emptyFieldNotify = notify.danger(error, info)
    } finally {
      updateSinglePublish($SinglePublish)
      apiCallBtnDisable = false
    }
  }
</script>

<svelte:window
  on:load={() => {
    push(`/publish/single?documentId=${query.documentId}`)
  }}
/>

{#if showConfirmationModal}
  <ConfirmationModal
    title="Confirmation for Publishing"
    content="I have thoroughly reviewed the document's metadata details and understand that this action is irreversible. I confirm my decision to proceed with publishing the document."
    on:click={() => {
      showConfirmationModal = false
    }}
    on:confirm={handlePublishConfirmation}
  />
{/if}

<svelte:head>
  <title>Single Document Publish</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div bind:this={mainDiv} class="mx-auto h-auto w-full max-w-[920px] pb-40 pt-6">
      <Header bind:apiCallBtnDisable bind:msg />
      <div class="relative flex min-h-[530px] flex-col justify-between gap-6 rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
        <div class="space-y-3">
          <p class="w-full select-none break-words text-justify text-sm text-gray-200 mobile:text-base sm:w-3/4 md:text-base">Please enter form fields to provided about the intended recipient,document and issuer of the document.In addition,title and expiry are optional details.</p>
          <div class="mobile:p-3">
            {#if $SinglePublish.Json}
              <h1 class="select-none text-2xl font-bold text-black dark:text-white">Metadata</h1>
              {#each Object.keys($SinglePublish.Json) as parent}
                <h3 class="my-3 select-none pl-3 text-base text-blue-500 mobile:pl-6 mobile:text-lg">
                  <strong class="capitalize">{parent}</strong>
                  Details
                </h3>
                <div class="space-y-3 pl-3">
                  {#each Object.entries($SinglePublish.Json[parent]) as [keys, values]}
                    <div class="flex w-full flex-col items-center justify-end gap-1 mobile:flex-row mobile:gap-6">
                      <div class="w-full select-none mobile:w-2/6 mobile:text-end">
                        <p class="text-sm capitalize text-gray-200 after:ml-0.5 after:text-red-500 mobile:font-medium {keys == 'Digital signature ID' || keys == 'Digital signature TXID' ? '' : "after:content-['*']"}  ">{keys}</p>
                      </div>
                      <div class="w-full mobile:w-4/6">
                        <input readonly={keys == "Digital signature ID" || keys == "Digital signature TXID"} required on:blur={(e) => checkMaxCharacters(e, parent, keys)} on:keypress={(e) => checkMaxCharacters(e, parent, keys)} on:blur={(e) => updateValue(e, parent, keys)} bind:value={values} placeholder="Enter value" class="w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />
                      </div>
                    </div>
                  {/each}
                </div>
                <AdditionalData bind:fields={$SinglePublish.fields} {parent} />
              {/each}
            {/if}
          </div>
          <div class="space-y-3 mobile:p-3">
            <h1 class="select-none text-2xl font-bold text-black dark:text-white">Options</h1>
            <div class=" flex w-full flex-col items-center justify-end gap-1 pl-3 mobile:flex-row mobile:gap-6">
              <div class="w-full select-none mobile:w-2/6 mobile:text-end">
                <p class="text-sm text-gray-200 mobile:font-medium">Webpage Title (Optional)</p>
              </div>
              <div class="w-full mobile:w-4/6">
                <input on:blur={(e) => checkMaxCharacters(e, "options", "title")} on:keypress={(e) => checkMaxCharacters(e, "options", "title")} on:blur={(e) => updateValue(e, "options", "title")} bind:value={$SinglePublish.optionsTitle} placeholder="Enter title" class="w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />
              </div>
            </div>
            <div class="flex w-full flex-col items-center justify-end gap-1 pl-3 mobile:flex-row mobile:gap-6">
              <div class="w-full select-none mobile:w-2/6 mobile:text-end">
                <p class="text-sm text-gray-200 mobile:font-medium">Expire On (Optional)</p>
              </div>
              <div class="relative w-full mobile:w-4/6">
                <input type="date" id="dateInput" bind:value={$SinglePublish.expiryOn} on:change={checkDate} placeholder="Enter date" style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'} ;" class="absolute z-20 h-[37.6px] w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />
                <div class="absolute right-3 top-2 z-10 text-gray-800 dark:text-slate-200">
                  <i class="fa-solid fa-calendar-days" />
                </div>
              </div>
            </div>
            {#if $SinglePublish.docketId}
              <div class="flex w-full flex-col items-center justify-end gap-1 pl-3 mobile:flex-row mobile:gap-6">
                <div class="w-full select-none mobile:w-2/6 mobile:text-end">
                  <p class="text-sm text-gray-200 mobile:font-medium">Docket</p>
                </div>
                <div class="w-full mobile:w-4/6">
                  <div class="w-full cursor-not-allowed rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 dark:text-white sm:text-sm">
                    {$SinglePublish.docketId}
                  </div>
                </div>
              </div>
            {/if}
            {#if $SinglePublish.signedPDFName}
              <div class="flex w-full items-center gap-6 pl-3 mobile:justify-end">
                <div class="w-auto select-none mobile:w-2/6 mobile:text-end">
                  <p class="font-medium text-gray-200">Signed PDF</p>
                </div>
                <div class="flex min-h-[40px] items-center justify-start mobile:w-4/6">
                  <div class="flex h-7 w-7 cursor-pointer items-center justify-center rounded-md bg-green-500 text-white hover:bg-green-600">
                    <i class="fa-solid fa-check" />
                  </div>
                </div>
              </div>
            {/if}
          </div>
        </div>
        <div class="flex items-center justify-end gap-3">
          <button
            on:click={() => {
              $SinglePublish.documentTemplateId = ""
              push(`/publish/single/choose_template`)
            }}
            type="button"
            class="flex h-9 w-auto min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-yellow-500 px-2 text-sm font-medium text-white hover:bg-yellow-600 hover:text-white focus:outline-none active:bg-yellow-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4"
          >
            <i class="fa-solid fa-rotate-left" />
            <span class="select-none md:block">&nbsp;&nbsp;Change Template&nbsp;</span>
          </button>
          <button on:click={nextPage} type="button" class="flex h-9 w-auto min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 md:w-32 lg:px-4">
            <span class="select-none md:block">&nbsp;Next&nbsp;&nbsp;</span>
            <i class="fa-solid fa-chevron-right" />
          </button>
        </div>
        {#if apiCallBtnDisable}
          <LoadingScreen {msg} />
        {/if}
      </div>
    </div>
  </div>
  <Footer />
</div>

<style>
  input#dateInput {
    position: relative;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
</style>
